<template>
    <p class="p1">
        <slot />
    </p>
</template>
